<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of GRN</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm(0)"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New GRN
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search GRN
              </h4> 
            </div>
          </div>
        </header>
        <div class="modal-body">
          
          <div class="row">
            <div class="col-md-4">
             <div style="display:flex">
              <label style="line-height: 2.5;">Supplier:</label>                 
                  <v-select style="width:100%" label="supplier_name" v-model="supplier" :options="supplierList"></v-select>
              </div>
            </div>
            <div class="col-md-4">
             <div style="display:flex">
              <label style="line-height: 2.5;">Location:</label>                 
                  <v-select style="width:100%;" label="site_name" v-model="location" :options="locationList"></v-select>
              </div>
            </div>
            <div class="col-md-4">
             <div style="display:flex">
              <label style="width:40%;line-height: 2.5;">Start Date:</label>
              <input
                type="date"
                class="form-control"
                @change="$refs.table.refresh()"
                id="start-date"
                v-model="startDate"
              />
              </div>
            </div>
            <div class="col-md-4">
             <div style="display:flex">
              <label style="width:40%;line-height: 2.5;">End Date:</label>
              <input
                type="date"
                class="form-control"
                id="end-date"
                v-model="endDate"
              />
              </div>
            </div>
            <div class="col-md-4">
              <div style="display:flex">
                <b-form-input
                id="filter-input"
                v-model="searchTerm"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
              <b-button style="border:1px solid #ccc;" @click="filter = searchTerm">Filter</b-button>
              </div>

            </div>
          </div>
          <hr/>
          
          <div class="co-md-12">
            <b-table id="item-table"
              :items="filteredList" 
              ref="table"
              primary-key="purchase_id"
              :fields="fields"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :filter="filter"
              hover
              :per-page="perPage"
              :current-page="currentPage">
              <!-- A virtual column -->
              <template #cell(sno)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
              </template>
              <template #cell(order_date)="data">
                {{ dateFormat(data.item.order_date) }}
              </template>
              <template #cell(purchase_id)="data">
                {{ 'LPO-' + data.item.purchase_id }}
              </template>
              <template #cell(action)="data">
                <a
                  v-on:click="viewLPO(data.item)"
                  class="btn label-info btn-xs"
                  style="float: left;display: block; width: 100%;margin-bottom:3px;"
                  ><i class="fa fa-eye"></i> View LPO</a
                >
                <a
                  v-on:click="showForm(data.item.purchase_id, false, false)"
                  class="btn label-warning btn-xs"
                  style="float: left;display: block; width: 100%;margin-bottom:3px;"
                  ><i class="fa fa-edit"></i> Edit</a
                >
                <a
                  v-on:click="showForm(data.item.purchase_id, false, true)"
                  class="btn label-success btn-xs"
                  style="float: left;display: block; width: 100%;"
                  ><i class="fa fa-copy"></i> Copy</a
                >
              </template>
            </b-table>
          <!-- Show pagination links -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="item-table"
              hide-ellipsis
              ></b-pagination>
          </div>
        </div>
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-10"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i :class="[showLPO ? 'fa-eye' : 'fa-edit', 'fa']"></i>
            {{itemId ? (showLPO ? '': 'Edit') : 'Add GRN'}} <span v-if="itemId">{{lpoNumber}}</span>
          </h4>
        </template>
        <template #body>
          <AddGrn
            v-if="!showLPO"
            :grnId="itemId"
            :isCopy="copyLPO"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
          <ViewPurchaseOrder
            v-if="showLPO"
            :purchaseId="itemId"
            :item="selectedItem"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
      <panel-modal
        v-if="showCartModal"
        class-list="col-md-6"
        @close="showCartModal = false"
      >
        <template #header>
          <h6>
            <i class="fa fa-list-ul"></i>
           Purchase Items
          </h6>          
        </template>
        <template #body>
          <table
              class="table table-striped table-bordered table-hover"
            >
              <thead>
                <tr>
                  <th width="5%">#</th>
                  <th width="10%">Product</th>
                  <th width="10%">Quantity</th>
                  <th width="10%">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in productList"
                  :key="item.purchase_item_id"
                >
                  <td id="sino"></td>
                  <td>
                    {{ item.product_name }}</td>
                  <td>
                    {{ item.quantity }}</td>
                  <td>
                    {{ item.unit_price }}</td>
                </tr>
              </tbody>
            </table>
        </template>
      </panel-modal>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddGrn from "../components/AddGrn.vue";
import ViewPurchaseOrder from "../components/ViewPurchaseOrder.vue";
import PanelModal from "../components/PanelModal.vue";
import { BTable, BPagination, BFormInput, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  name: "Purchase",

  components: {
    AddGrn,
    ViewPurchaseOrder,
    PanelModal,
    BPagination,
    BTable,
    BFormInput,
    BButton,
    vSelect
  },
  data() {
    return {
      showLPO: false,
      copyLPO: false,
      showFormModal: false,
      showCartModal: false,
      startDate: '',
      endDate: '',
      itemList: [],
      supplierList: [],
      projectList: [],
      locationList: [],
      supplier: null,
      project: null,
      location: null,
      itemId: "",
      selectedItem: null,
      productList: [],
      searchTerm: null,
      filter: null,
      filterOn: ['project_name', 'supplier_name', 'site_name', 'purchase_id'],
      perPage: 10,
      currentPage: 1,
     // totalRows: 1,
      filteredCount: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'order_date', label: 'Order Date'},
        { key:'purchase_id', label: 'LPO #'},
        { key:'supplier_name', label: 'Supplier'},
        { key:'amount', label: 'Value'},
        { key:'project_name', label: 'Project'},
        { key:'site_name', label: 'Site/Location'},
        { key:'action', label: 'Actions'},
        ]
    };
  },
  computed: {
    lpoNumber: function () {
      return 'LPO-' + this.itemId;
    },
    filteredList: function () {
       const startDate = this.startDate ? new Date(this.startDate) : null
       const endDate = this.startDate ? new Date(this.endDate) : null
       const supplier = this.supplier
       const project = this.project
       const location = this.location
       const list = this.itemList.filter(function(item) {
        const orderDate = new Date(item.order_date)
        const dateFilter =  (startDate && (orderDate < startDate) ? false : true) && (endDate && (orderDate > endDate) ? false : true)
        const supplierFilter = supplier ? item.supplier_id == supplier.supplier_id : true;
        const projectFilter = project ? item.project_id == project.project_id : true;
        const siteFilter = location ? item.site_id == location.site_id : true;
        return dateFilter && supplierFilter && projectFilter && siteFilter 
      });
      return list
    },
    totalRows: function () {
      return this.filter && this.filter.length ? this.filteredCount : this.filteredList.length
    }
  },
  methods: {
    setProject: function (value) {
      this.getLocations(value.project_id);
    },
    dateFormat: function(date) {
      /* var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }; */
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-GB");
      return dateformat;
    },
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_purchases", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.purchaseList;
          }
        });
    },
    getCartList: function(id) {
      const list = {
        filter: {
          purchase_id: id
        },
      };
      api
        .request("post", "GeneralApis/get_purchase_items", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.productList = response.data.values;
          } else {
            this.productList = data.cartList;
          }
        });
    },
    showForm: function(purchaseid, show=false, copy=false) {
      this.copyLPO = copy;
      this.showLPO = show;
      this.itemId = purchaseid;
      this.showFormModal = true;
    },
    viewLPO: function(item) {
      this.selectedItem = item;
      this.showLPO = true;
      this.itemId = item.purchase_id;
      this.showFormModal = true;
    },
    showCart: function(purchaseid) {
      this.getCartList(purchaseid)
      this.showCartModal = true;
    },
    onFiltered(filteredItems) {
      this.filteredCount = filteredItems.length
      this.currentPage = 1
    },
    getSuppliers: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_suppliers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.supplierList = [];
          } else {
            this.supplierList = data.supplierList;
          }
        });
    },
    getProjects: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_projects", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.projectList = [];
          } else {
            this.projectList = data.projectList;
          }
        });
    },
    getLocations: function(id = null) {
      const list = { filter: {project_id: id} };
      api
        .request("post", "GeneralApis/get_sites", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.locationList = [];
          } else {
            this.locationList = data.siteList;
          }
        });
    }
  },
  mounted(){
    this.getList()
    this.getSuppliers()
    this.getProjects()
    this.getLocations()
  }
};
</script>
